import React from "react";
import Icon from "components/AppIcon";

const MetricsPanel = ({ metrics }) => {
  const cards = [
    {
      label: "Registros Pendientes",
      value: metrics?.pending,
      icon: "Clock",
      color: "text-amber-600",
      bg: "bg-amber-50",
      border: "border-amber-200",
    },
    {
      label: "Activaciones Recientes",
      value: metrics?.recentActivations,
      icon: "UserCheck",
      color: "text-emerald-600",
      bg: "bg-emerald-50",
      border: "border-emerald-200",
    },
    {
      label: "Usuarios Activos",
      value: metrics?.active,
      icon: "Users",
      color: "text-teal-600",
      bg: "bg-teal-50",
      border: "border-teal-200",
    },
    {
      label: "Alertas del Sistema",
      value: metrics?.alerts,
      icon: "AlertTriangle",
      color: "text-red-600",
      bg: "bg-red-50",
      border: "border-red-200",
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-6">
      {cards?.map((card) => (
        <div
          key={card?.label}
          className={`rounded-xl border ${card?.border} ${card?.bg} p-4 flex items-center gap-3 shadow-sm`}
        >
          <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${card?.bg} border ${card?.border}`}>
            <Icon name={card?.icon} size={20} className={card?.color} />
          </div>
          <div className="min-w-0">
            <p className="text-xl md:text-2xl font-bold font-heading" style={{ color: "var(--color-foreground)" }}>
              {card?.value}
            </p>
            <p className="text-xs font-caption truncate" style={{ color: "var(--color-muted-foreground)" }}>
              {card?.label}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsPanel;